import { api, extractErrorMessage } from './client';

/**
 * Multipart upload with optional progress callback (0–100).
 * Uses axios onUploadProgress so large images show a visible progress line.
 */
export async function uploadWithProgress({
  url,
  file,
  fieldName = 'file',
  extraFields = {},
  onProgress,
  timeout = 120000,
}) {
  const formData = new FormData();
  formData.append(fieldName, file);
  Object.entries(extraFields).forEach(([key, value]) => {
    if (value != null) {
      formData.append(key, value);
    }
  });

  try {
    const { data } = await api.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout,
      onUploadProgress: (event) => {
        if (!onProgress) {
          return;
        }
        if (event.total) {
          onProgress(Math.round((event.loaded * 100) / event.total));
        } else {
          onProgress(null);
        }
      },
    });
    return data;
  } catch (err) {
    throw new Error(extractErrorMessage(err, 'Upload failed'));
  }
}
